import { selectAccountChatRoomId } from 'selectors/app/selectAccountPreferences'
import { doUpdateChatBotState } from '../actions/botState'

// gets the status of bots (skills) running state
// keep in mind we only get states that were sent down from API
let isSubscribed = false
export function subscribeChatBotState(client) {
  return (dispatch, getState) => {
    if (isSubscribed) return
    const accountRoomId = selectAccountChatRoomId(getState())
    client.on('event', event => {
      if (event.getType() !== 'g.skills.state') return
      if (event.getRoomId() !== accountRoomId) return
      dispatch(doUpdateChatBotState(event))
    })
    isSubscribed = true

    // Load the first state. Make sure we do this after we have subscribed to the event.
    // to prevent the dispatch below from potentially causing a double subscription.
    const accountRoom = client.getRoom(accountRoomId)
    const botStateEvent =
      accountRoom &&
      accountRoom.currentState.getStateEvents('g.skills.state', '')
    if (botStateEvent) {
      dispatch(doUpdateChatBotState(botStateEvent))
    }
  }
}
